import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Toast } from 'primereact/toast';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/geral.css';
import { PendenciasWizard, setPendencia } from './ValidacaoWizard';

class DadosSolicitacao extends Component {
  state = {
    carater: null,
    dataSugerida: null,
    centroCirurgico: null,
    listaLateralidade: [
      { letra: 'D', nome: 'Direita' },
      { letra: 'E', nome: 'Esquerda' },
      { letra: 'N', nome: 'Não se aplica' },
    ],
    lateralidade: '',
    indicacaoClinica: null,
    cidPrincipal: null,
    cidsSecundarios: [],
    dataInternacao: null,
    listaCentoCirurgico: [],
    listaCidPrincipal: [],
    listaCidSecundario: [],
    salaCirurgia: null,
    internacao: null,
    atendimento: null,
    listaProfissional: [],
    profissionalResponsavel: null,
    bloqueiaSelecionarResponsavel: false,
    listaOncologica: [{ id: 1, descricao: 'Sim' }, { id: 2, descricao: 'Não' }],
    eOncologica: null,
  };

  alimentarStates = () => {
    const salaCirurgia = localStorage.getItem('salaCirurgia');
    const profissionalResponsavel = localStorage.getItem('profissionalResponsavel');
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = localStorage.getItem('centroCirurgico');
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const cidPrincipal = localStorage.getItem('cidPrincipal');
    const cidsSecundarios = localStorage.getItem('cidsSecundarios');
    const dataInternacao = localStorage.getItem('dataInternacao');
    const internacao = localStorage.getItem('internacao');
    const atendimento = localStorage.getItem('atendimento');
    const eOncologica = localStorage.getItem('eOncologica');

    if (eOncologica) {
      this.setState({ eOncologica });
    }
    if (salaCirurgia) this.setState({ salaCirurgia: JSON.parse(salaCirurgia) });
    if (profissionalResponsavel)
      this.setState({ profissionalResponsavel: JSON.parse(profissionalResponsavel) });
    if (dataSugerida) {
      this.setState({ dataSugerida });
      setPendencia(1, PendenciasWizard.dataSugerida);
    }
    if (centroCirurgico) {
      this.setState({ centroCirurgico: JSON.parse(centroCirurgico) });
      setPendencia(1, PendenciasWizard.centroCirurgico);
    }
    if (lateralidade) {
      this.setState({ lateralidade });
      setPendencia(1, PendenciasWizard.lateralidade);
    }
    if (indicacaoClinica) {
      this.setState({ indicacaoClinica });
      setPendencia(1, PendenciasWizard.indicacaoClinica);
    }
    if (cidPrincipal) {
      this.setState({ cidPrincipal: JSON.parse(cidPrincipal) });
      setPendencia(1, PendenciasWizard.cidPrincipal);
    }
    if (cidsSecundarios) this.setState({ cidsSecundarios: JSON.parse(cidsSecundarios) });
    if (internacao) {
      this.setState({ internacao: JSON.parse(internacao) });
    }
    if (atendimento) {
      this.setState({ atendimento: JSON.parse(atendimento) });
    }
    if (dataInternacao) {
      localStorage.setItem('dataInternacao', dataInternacao);
      setPendencia(1, PendenciasWizard.dataInternacao);
    }
  };

  componentDidMount() {
    this.alimentarStates();

    const {
      statusInicial,
      caraterUrgencia,
      caraterUrgenciaLegado,
      caraterEletivo,
      caraterEletivoLegado,
      modalidadeAmbulatorial,
      acomodacaoPadrao,
      acomodacaoPadraoNome,
      perspectivaValidacaoDosDiasUteis,
      perspectivaValidacaoDosDiasCorridos,
      perspectivaValidacaoDasHorasUteis,
      perspectivaValidacaoDasHorasCorridas,
    } = JSON.parse(localStorage.getItem('configuracoes'));

    this.setState({
      caraterUrgencia,
      caraterUrgenciaLegado,
      caraterEletivo,
      caraterEletivoLegado,
      modalidadeAmbulatorial,
      acomodacaoPadrao,
      acomodacaoPadraoNome,
      perspectivaValidacaoDosDiasUteis,
      perspectivaValidacaoDosDiasCorridos,
      perspectivaValidacaoDasHorasUteis,
      perspectivaValidacaoDasHorasCorridas,
    });

    dominioDemandaCirurgica.get(`/api/statusPedidoDetail/${statusInicial}`).then(response => {
      this.setState({
        perspectivaValidacaoDosDias: response.data.perspectivaValidacaoDosDias,
        slaCaraterUrgencia: response.data.prazoLimiteSLAUrgencia,
        slacaraterEletivo: response.data.prazoLimiteSLAEletivo,
      });
    });

    const profissional = JSON.parse(localStorage.getItem('profissional'));

    const centrosCirurgicosProfissional = profissional?.centrosCirurgicos ?? [];
    const centroCirurgicoPermitido = JSON.parse(localStorage.getItem('centroCirurgicoPermitido'));

    if (centroCirurgicoPermitido) this.setState({ listaCentoCirurgico: centroCirurgicoPermitido.filter(item => centrosCirurgicosProfissional.includes(item.id)) });
    else
      dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
        this.setState({ listaCentoCirurgico: response.data.filter(item => centrosCirurgicosProfissional.includes(item.id)) });
      });

    const cidPrincipalPermitido = JSON.parse(localStorage.getItem('cidPrincipalPermitido'));
    if (cidPrincipalPermitido) this.setState({ listaCidPrincipal: cidPrincipalPermitido });
    else
      dominioDemandaCirurgica.get('/api/cid').then(response => {
        this.setState({ listaCidPrincipal: response.data });
      });

    const cidSecundarioPermitido = JSON.parse(localStorage.getItem('cidSecundarioPermitido'));
    if (cidSecundarioPermitido) this.setState({ listaCidSecundario: cidSecundarioPermitido });
    else
      dominioDemandaCirurgica.get('/api/cid').then(response => {
        this.setState({ listaCidSecundario: response.data });
      });

    const lateralidadePermitida = JSON.parse(localStorage.getItem('lateralidadePermitida'));
    if (lateralidadePermitida)
      this.setState({
        listaLateralidade: this.state.listaLateralidade.filter(lateralidade =>
          lateralidadePermitida.includes(lateralidade.letra)
        ),
      });

    if (profissional.residente)
      dominioDemandaCirurgica
        .get(`/api/listarProfissionalResponsavel/${profissional.profissional_id}`)
        .then(response => {
          this.setState({ listaProfissional: response.data });
        });
    else {
      const profissionalResponsavel = {
        id: profissional.profissional_id,
        crm: profissional.crm,
        nome: profissional.nome,
      };

      this.setState({
        profissionalResponsavel,
      });

      localStorage.setItem('profissionalResponsavel', JSON.stringify(profissionalResponsavel));
      setPendencia(1, PendenciasWizard.profissionalResponsavel);
      this.setState({ bloqueiaSelecionarResponsavel: true });
    }
  }

  formatDate = date => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 13000,
    });
  }

  differenceInDaysCustom = (startDate, finalDate) => {
    const timeDiff = Math.abs(finalDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  };

  differenceInHoursCustom = (startDate, finalDate) => {
    const timeDiff = Math.abs(finalDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600));
    return diffDays;
  };

  handleValidarDataSugerida = async e => {
    const { value } = e.target;
    const dataSugeridaFormatada = value.slice(0, 10);
    const dataHoje = new Date();
    dataHoje.setHours(dataHoje.getHours() - 3);
    const dataFormatada = dataHoje.toISOString().substr(0, 16);
    const dataFormatadaHoje = dataFormatada.slice(0, 10);

    if (dataSugeridaFormatada === dataFormatadaHoje) {
      this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');
      document.getElementById('dataSugerida').value = '';
      return;
    }

    const slaCarater = this.state.slacaraterEletivo;
    const dataSugeridaOnlyDate = new Date(dataSugeridaFormatada);
    const dataAtualOnlyDate = new Date(dataFormatadaHoje);
    const differenceInDays = this.differenceInDaysCustom(dataAtualOnlyDate, dataSugeridaOnlyDate);

    if (differenceInDays <= slaCarater) {
      this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');
      document.getElementById('dataSugerida').value = '';
    } else {
      localStorage.setItem('dataSugerida', value);
      this.setState({ dataSugerida: value });
      setPendencia(1, PendenciasWizard.dataSugerida);
    }
  };

  render() {
    return (
      <Container id="dados-solicitacao">
        <Toast
          className="toast-dados-solicitacao"
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados da Solicitação</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="datetime-local"
              name="dataSugerida"
              variant="outlined"
              fullWidth
              id="dataSugerida"
              label="Data Sugerida da Cirurgia"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataSugerida}
              onChange={e => {
                this.handleValidarDataSugerida(e);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="centroCirurgico"
              options={this.state.listaCentoCirurgico}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              disableClearable
              value={this.state.centroCirurgico}
              onChange={(e, values) => {
                localStorage.setItem('centroCirurgico', JSON.stringify(values));
                this.setState({ centroCirurgico: values });
                setPendencia(1, PendenciasWizard.centroCirurgico);
              }}
              renderInput={params => (
                <TextField {...params} label="Centro Cirúrgico" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="profissionalResponsavel"
              options={this.state.listaProfissional}
              getOptionLabel={option => `${option.crm} - ${option.nome}`}
              fullWidth
              disableClearable
              disabled={this.state.bloqueiaSelecionarResponsavel}
              value={this.state.profissionalResponsavel}
              onChange={(e, value) => {
                localStorage.setItem('profissionalResponsavel', JSON.stringify(value));
                this.setState({ profissionalResponsavel: value });
                setPendencia(1, PendenciasWizard.profissionalResponsavel);
              }}
              renderInput={params => (
                <TextField {...params} label="Responsável" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              select
              name="lateralidade"
              variant="outlined"
              fullWidth
              id="lateralidade"
              label="Lateralidade"
              value={this.state.lateralidade}
              onChange={e => {
                localStorage.setItem('lateralidade', e.target.value);
                this.setState({ lateralidade: e.target.value });
                setPendencia(1, PendenciasWizard.lateralidade);
              }}
            >
              {this.state.listaLateralidade.map(lateralidade => (
                <MenuItem value={lateralidade.letra}> {lateralidade.nome} </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              multiline
              rows={5}
              rowsMax={15}
              name="indicacaoClinica"
              variant="outlined"
              fullWidth
              id="indicacaoClinica"
              label="Indicação Cirúrgica"
              value={this.state.indicacaoClinica}
              onChange={e => {
                localStorage.setItem('indicacaoClinica', e.target.value);
                this.setState({ indicacaoClinica: e.target.value });
                if (e.target.value.length >= 20) setPendencia(1, PendenciasWizard.indicacaoClinica);
              }}
              inputProps={{
                maxlength: 65535,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="cidPrincipal"
              options={this.state.listaCidPrincipal}
              getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
              fullWidth
              value={this.state.cidPrincipal}
              onChange={(e, values) => {
                localStorage.setItem('cidPrincipal', JSON.stringify(values));
                this.setState({ cidPrincipal: values });
                setPendencia(1, PendenciasWizard.cidPrincipal);
              }}
              renderInput={params => (
                <TextField {...params} label="CID Principal" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="cidsSecundarios"
              options={this.state.listaCidSecundario}
              getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
              value={this.state.cidsSecundarios}
              onChange={(e, values) => {
                localStorage.setItem('cidsSecundarios', JSON.stringify(values));
                this.setState({ cidsSecundarios: values });
              }}
              filterSelectedOptions
              renderInput={params => (
                <TextField {...params} variant="outlined" label="CIDs Secundários" />
              )}
            />
          </Grid>

          {/* Novo Campo - Oncológico */}
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="eOncologica"
              options={this.state.listaOncologica}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              disableClearable
              value={this.state.eOncologica?.descricao}
              onChange={(e, values) => {
                this.setState({ eOncologica: JSON.stringify(values) });
                localStorage.setItem('eOncologica', JSON.stringify(values));
              }}
              renderInput={params => (
                <TextField {...params} label="É uma cirurgia oncológica?" variant="outlined" />
              )}
            />
          </Grid>
        </Grid>
      </Container>
    );
  }
}
export default DadosSolicitacao;
